import React from 'react'
import Title from '../components/dashContent/Title'
import { Outlet } from 'react-router-dom';

const Users = () => {
  return (
    <div className='m-1'>
      <Title text="Gestão de Usuários"/>
      <Outlet>

      </Outlet>
    </div>
  )
}

export default Users